import { Action } from '@ngrx/store';
import {
    FileUploadEntry,
    FileUploadFilterInput
} from 'app/api/file-upload.api.service';
import { KeyStringFilterInput } from 'app/api/common.api.types';

export interface FileUploadQuery {
    companyId: string;
    key?: KeyStringFilterInput;
    filter?: FileUploadFilterInput;
}

export enum FileUploadActionTypes {
    FileUploadRequested = '[FileUpload View] FileUpload requested',
    FileUploadLoaded = '[FileUpload API] FileUpload loaded',
    FileUploadCancelled = '[FileUpload API] FileUpload cancelled',
    FileUploadEntryCreateRequested = '[FileUpload View] FileUpload entry create requested',
    FileUploadEntryCreated = '[FileUpload API] FileUpload entry created',
    FileUploadEntryCreateCancelled = '[FileUpload API] FileUpload entry create cancelled',
    FileUploadEntryUpdateRequested = '[FileUpload View] FileUpload entry update requested',
    FileUploadEntryUpdated = '[FileUpload API] FileUpload entry updated',
    FileUploadEntryUpdateCancelled = '[FileUpload API] FileUpload entry update cancelled',
}

// LOAD ENTRIES
export class FileUploadRequested implements Action {
    readonly type = FileUploadActionTypes.FileUploadRequested;
    constructor(public payload: FileUploadQuery) {}
}
export class FileUploadLoaded implements Action {
    readonly type = FileUploadActionTypes.FileUploadLoaded;
    constructor(public payload: { companyId: string, fileUpload: FileUploadEntry[] }) {}
}
export class FileUploadCancelled implements Action {
    readonly type = FileUploadActionTypes.FileUploadCancelled;
    constructor(public payload: { companyId: string, errorMessage: string }) {}
}

// CREATE ENTRY
export class FileUploadEntryCreateRequested implements Action {
    readonly type = FileUploadActionTypes.FileUploadEntryCreateRequested;
    constructor(public payload: { entry: FileUploadEntry }) {}
}
export class FileUploadEntryCreated implements Action {
    readonly type = FileUploadActionTypes.FileUploadEntryCreated;
    constructor(public payload: { entry: FileUploadEntry }) {}
}
export class FileUploadEntryCreateCancelled implements Action {
    readonly type = FileUploadActionTypes.FileUploadEntryCreateCancelled;
    constructor(public payload: { entry: FileUploadEntry, errorMessage: string }) {}
}

// UPDATE ENTRY
export class FileUploadEntryUpdateRequested implements Action {
    readonly type = FileUploadActionTypes.FileUploadEntryUpdateRequested;
    constructor(public payload: { entry: FileUploadEntry }) {}
}
export class FileUploadEntryUpdated implements Action {
    readonly type = FileUploadActionTypes.FileUploadEntryUpdated;
    constructor(public payload: { entry: FileUploadEntry }) {}
}
export class FileUploadEntryUpdateCancelled implements Action {
    readonly type = FileUploadActionTypes.FileUploadEntryUpdateCancelled;
    constructor(public payload: { entry: FileUploadEntry, errorMessage: string }) {}
}

export type FileUploadActions =
  FileUploadRequested
    | FileUploadLoaded
    | FileUploadCancelled
    | FileUploadEntryCreateRequested
    | FileUploadEntryCreated
    | FileUploadEntryCreateCancelled
    | FileUploadEntryUpdateRequested
    | FileUploadEntryUpdated
    | FileUploadEntryUpdateCancelled;
